import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";
import Card from "@mui/material/Card";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// import Icon from "@mui/material/Icon";

import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import { toast } from "react-toastify";

// @mui material components
import { Backdrop } from "@mui/material";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";
import { CSVLink } from "react-csv";

// Custom standard components
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";

import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { CustomToastContent } from "../../examples/CustomToastContent/index";

import {
  createManufacturer,
  deleteManufacturer,
  editManufacturer,
  getManufacturer,
  getSubModulesByRoleId,
  uploadCsvForManufacturer,
} from "../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflowY: "hidden",
  overflowX: "hidden",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
  overflowY: "hidden",
  overflowX: "hidden",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Manufacturer = ({
  getManufacturerReducer,
  getManufacturer,
  createManufacturer,
  editManufacturer,
  deleteManufacturer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  uploadCsvForManufacturer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data?.userId || "system";
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const [uploadCsvData, setUploadCsvData] = useState(null);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "d51e5caa-b714-4739-877a-3b78d6f9d263",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "8d35a579-c3b1-4ceb-a1eb-70e2e025e133",
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "6fd9218e-53e3-49ec-85bc-ef986f9ede86",
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "f15bb522-b966-4072-b97a-37d6a10d973d",
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "7bdbed78-729f-43c8-aac6-d194f6091629",
    )
    : null;

  const [loading, setLoading] = useState(true);
  const [showUploadPanel, setShowUploadPanel] = useState(false);

  // Fetch Initial Data
  useEffect(() => {
    getManufacturer(null, jwtToken);
  }, [jwtToken]);

  const handleUploadClick = () => {
    setShowUploadPanel(!showUploadPanel);
    setUploadCsvData(null);
  };

  // DataTable State
  const [state, setState] = useState({
    columns: [
      { Header: "ID", accessor: "manufacturerId" },
      { Header: "Company Name", accessor: "companyName" },
      { Header: "Email", accessor: "email" },
      { Header: "National Code", accessor: "nationalCode" },
      { Header: "City", accessor: "city" },
      { Header: "Zip Code", accessor: "zipCode" },
      { Header: "Street", accessor: "street" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const headers = [
    { label: "Company Name", key: "companyName" },
    { label: "Email", key: "email" },
    { label: "National Code", key: "nationalCode" },
    { label: "City", key: "city" },
    { label: "Zip Code", key: "zipCode" },
    { label: "Street", key: "street" },
  ];

  const headersForTemp = [
    { label: "companyName", key: "companyName" },
    { label: "email", key: "email" },
    { label: "nationalCode", key: "nationalCode" },
    { label: "city", key: "city" },
    { label: "zipCode", key: "zipCode" },
    { label: "street", key: "street" },
  ];

  const csvLink = {
    filename: "Manufacturer List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Manufacturer Upload Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const uploadCsvHandler = async () => {
    let data = new FormData();
    data.append("file", uploadCsvData);

    try {
      let res = await uploadCsvForManufacturer(data, jwtToken);
      if (res?.status === true || res?.data?.status === true) {
        getManufacturer(null, jwtToken);
        setUploadCsvFilter(false);
      }
      showUploadNotification(res);

    } catch (error) {
      showUploadNotification(error);
    }
  };

  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  useEffect(() => {
    let tempMappedActivity = [];
    let data = getManufacturerReducer?.manufacturer?.data
      ? getManufacturerReducer.manufacturer.data
      : [];

    setLoading(getManufacturerReducer?.loading || false);

    data.map((item) => {
      const itemObject = {
        manufacturerId: item.manufacturerId,
        companyName: item.companyName,
        email: item.email,
        nationalCode: item.nationalCode,
        city: item.city,
        zipCode: item.zipCode,
        street: item.street,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateModal(item)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
  }, [getManufacturerReducer]);

  // ================= CREATE LOGIC =================
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isSuccessCreate, setIsSuccessCreate] = useState(false);
  const [isErrorCreate, setIsErrorCreate] = useState(false);
  const [errorMsgCreate, setErrorMsgCreate] = useState("");
  const [createButtonName, setCreateButtonName] = useState("Create");

  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);
    formik.setErrors({});
  };

  const handleCloseCreateModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenCreateModal(false);
    formik.setErrors({});
    formik.resetForm();
  };

  useEffect(() => {
    if (isSuccessCreate) setTimeout(() => setIsSuccessCreate(false), 3000);
    if (isErrorCreate) setTimeout(() => setIsErrorCreate(false), 3000);
  }, [isSuccessCreate, isErrorCreate]);

  const initialValues = {
    companyName: "",
    street: "",
    zipCode: "",
    city: "",
    nationalCode: "",
    email: "",
  };

  const validationSchema = Yup.object({
    companyName: Yup.string().required("  "),
    street: Yup.string().required("  "),
    zipCode: Yup.number().integer("Must be an integer").required("  "),
    city: Yup.string().required("  "),
    nationalCode: Yup.string().required("  "),
    email: Yup.string().email("Invalid email format").required("  "),
  });

  const onSubmit = async (values, { resetForm }) => {
    setCreateButtonName("Please wait...");
    const payload = {
      companyName: values.companyName,
      street: values.street,
      zipCode: values.zipCode,
      city: values.city,
      nationalCode: values.nationalCode,
      email: values.email,
      cdBy: userId,
    };

    let res = await createManufacturer(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreate(true);
      setTimeout(() => {
        setCreateButtonName("Create");

        getManufacturer(null, jwtToken);
        handleCloseCreateModal();
      }, 2000);
    } else {
      setErrorMsgCreate(res?.data?.msg || "Something went wrong");
      setIsErrorCreate(true);
      setCreateButtonName("Create");
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  // ================= EDIT LOGIC =================
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [editButtonName, setEditButtonName] = useState("Update");

  const handleOpenUpdateModal = (data) => {
    setSingleDataForUpdate(data);
    setOpenUpdateModal(true);
  };

  const handleCloseUpdateModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenUpdateModal(false);
    formikForUpdate.resetForm();
  };

  useEffect(() => {
    if (isSuccessForUpdate)
      setTimeout(() => setIsSuccessForUpdate(false), 3000);
    if (isErrorForUpdate) setTimeout(() => setIsErrorForUpdate(false), 3000);
  }, [isSuccessForUpdate, isErrorForUpdate]);

  const initialValueForUpdate = {
    manufacturerId: singleDataForUpdate.manufacturerId || "",
    companyName: singleDataForUpdate.companyName || "",
    street: singleDataForUpdate.street || "",
    zipCode: singleDataForUpdate.zipCode || "",
    city: singleDataForUpdate.city || "",
    nationalCode: singleDataForUpdate.nationalCode || "",
    email: singleDataForUpdate.email || "",
  };

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    const payload = {
      manufacturerId: values.manufacturerId,
      companyName: values.companyName,
      street: values.street,
      zipCode: values.zipCode,
      city: values.city,
      nationalCode: values.nationalCode,
      email: values.email,
      udBy: userId,
    };

    let res = await editManufacturer(payload, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getManufacturer(null, jwtToken);
      setTimeout(() => {
        handleCloseUpdateModal();
        setEditButtonName("Update");
      }, 2000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.msg || "Failed to update");
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    validationSchema: validationSchema,
    onSubmit: onSubmitForUpdate,
    enableReinitialize: true,
  });

  // ================= DELETE LOGIC =================
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);
  const [isErrorForDelete, setIsErrorForDelete] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const handleOpenDeleteModal = (data) => {
    setSingleDataForDelete(data);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (isSuccessForDelete)
      setTimeout(() => setIsSuccessForDelete(false), 2000);
    if (isErrorForDelete) setTimeout(() => setIsErrorForDelete(false), 3000);
  }, [isSuccessForDelete, isErrorForDelete]);

  const deleteRecord = async () => {
    setDeleteButtonName("Please wait...");
    let id = singleDataForDelete.manufacturerId;
    let cd = userId;

    let res = await deleteManufacturer(id, cd, jwtToken);

    if (res.status) {
      setIsSuccessForDelete(true);
      getManufacturer(null, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 2000);
    } else {
      setIsErrorForDelete(true);
      setErrorMsgForDelete(res?.data?.msg || "Failed to delete");
      setDeleteButtonName("Delete");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3} mb={-2.5}>
        <Grid container spacing={6}>

          <Grid item xs={12}>
            <Card>

              {/* Header Actions */}
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={0}
                mb={-4.5}
                mt={-1}
              >
                <MDBox
                  color="text"
                  px={2}
                  ml={1}
                  mb={5}
                  mt={0.5}
                  display="flex"
                  alignItems="center"
                >
                  {allocateAccess && (
                    <MDBox display="flex" alignItems="center">
                      <Tooltip>
                        <CreateButton
                          tooltip="Add Manufacturer"
                          color="info"
                          variant="contained"
                          type="button"
                          iconOnly
                          onClick={handleOpenCreateModal}
                          style={{ borderRadius: "5px" }}
                          size="small"
                        >
                          <Icon>add</Icon>
                        </CreateButton>
                      </Tooltip>

                      <CSVLink {...csvLink}>
                        <DownloadDataButton
                          tooltip="Download Manufacturer List"
                          style={{ marginLeft: "1rem" }}
                          type="button"
                          variant="outlined"
                          color="error"
                          iconOnly
                        >
                          <Icon>download</Icon>
                        </DownloadDataButton>
                      </CSVLink>

                      <UploadButton
                        tooltip="Upload CSV"
                        style={{ marginLeft: "1rem", marginTop: "2px" }}
                        type="button"
                        variant={showUploadPanel ? "contained" : "outlined"}
                        color="info"
                        iconOnly
                        onClick={handleUploadClick}
                      >
                        <Icon>upload</Icon>
                      </UploadButton>

                      <CSVLink {...csvLink2}>
                        <DownloadButton
                          tooltip="Download Template"
                          style={{ marginLeft: "1rem" }}
                          type="button"
                          variant="outlined"
                          color="error"
                          iconOnly
                        >
                          <Icon>description</Icon>
                        </DownloadButton>
                      </CSVLink>

                      {showUploadPanel && (
                        <MDBox
                          display="flex"
                          alignItems="center"
                          ml={2}
                          p={0.5}
                          px={2}
                        >
                          <input
                            className="choose_file"
                            type="file"
                            accept=".csv"
                            onChange={(e) =>
                              setUploadCsvData(e.target.files[0])
                            }
                            style={{ width: "200px" }}
                          />

                          <MDButton
                            disabled={
                              !uploadCsvData?.name ||
                              uploadCsvData?.type !== "text/csv"
                            }
                            variant="contained"
                            color="info"
                            style={{ marginLeft: "1rem" }}
                            onClick={uploadCsvHandler}
                          >
                            UPLOAD
                          </MDButton>

                          <IconButton
                            size="small"
                            onClick={() => setShowUploadPanel(false)}
                            style={{ marginLeft: "10px", color: "gray" }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </MDBox>
                      )}
                    </MDBox>
                  )}
                </MDBox>
              </MDBox>

              {/* DataTable */}
              <MDBox pt={0}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                />
              </MDBox>

              {/* CREATE MODAL */}
              <Modal open={openCreateModal} onClose={handleCloseCreateModal}>
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography
                      variant="h5"
                      fontWeight="medium"
                      flexGrow={1}
                    >
                      Create Manufacturer
                    </MDTypography>
                    <Tooltip title="Close">
                      <IconButton
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                        onClick={handleCloseCreateModal}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">
                              Company Name
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="companyName"
                              fullWidth
                              autoComplete="off"
                              // placeholder="Enter company name"
                              value={formik.values.companyName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.companyName &&
                                Boolean(formik.errors.companyName)
                              }
                            />
                            {formik.touched.companyName &&
                              formik.errors.companyName && (
                                <TextError msg={formik.errors.companyName} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">Email</MDTypography>
                            <MDInput
                              size="small"
                              type="email"
                              name="email"
                              fullWidth
                              autoComplete="off"
                              // placeholder="Enter email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.email &&
                                Boolean(formik.errors.email)
                              }
                            />
                            {formik.touched.email && formik.errors.email && (
                              <TextError msg={formik.errors.email} />
                            )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">
                              National Code
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="nationalCode"
                              fullWidth
                              autoComplete="off"
                              // placeholder="Enter national code"
                              value={formik.values.nationalCode}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.nationalCode &&
                                Boolean(formik.errors.nationalCode)
                              }
                            />
                            {formik.touched.nationalCode &&
                              formik.errors.nationalCode && (
                                <TextError msg={formik.errors.nationalCode} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">City</MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="city"
                              fullWidth
                              autoComplete="off"
                              // placeholder="Enter city"
                              value={formik.values.city}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.city &&
                                Boolean(formik.errors.city)
                              }
                            />
                            {formik.touched.city && formik.errors.city && (
                              <TextError msg={formik.errors.city} />
                            )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">Zip Code</MDTypography>
                            <MDInput
                              size="small"
                              type="number"
                              name="zipCode"
                              fullWidth
                              autoComplete="off"
                              // placeholder="Enter zip code"
                              value={formik.values.zipCode}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.zipCode &&
                                Boolean(formik.errors.zipCode)
                              }
                            />
                            {formik.touched.zipCode &&
                              formik.errors.zipCode && (
                                <TextError msg={formik.errors.zipCode} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">Street</MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="street"
                              fullWidth
                              autoComplete="off"
                              // placeholder="Enter street"
                              value={formik.values.street}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.street &&
                                Boolean(formik.errors.street)
                              }
                            />
                            {formik.touched.street &&
                              formik.errors.street && (
                                <TextError msg={formik.errors.street} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12}>
                          <Collapse in={isErrorCreate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsErrorCreate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgCreate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessCreate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsSuccessCreate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Created Successfully
                            </Alert>
                          </Collapse>
                          <MDBox mt={2}>
                            <MDButton
                              color="info"
                              type="submit"
                              fullWidth
                              disabled={createButtonName === "Please wait..."}
                            >
                              {createButtonName}
                            </MDButton>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              {/* UPDATE MODAL */}
              <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
                <MDCard sx={styleForEdit}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography
                      variant="h4"
                      fontWeight="medium"
                      flexGrow={1}
                    >
                      Update Manufacturer
                    </MDTypography>
                    <Tooltip title="Close">
                      <IconButton
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                        onClick={handleCloseUpdateModal}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">
                              Company Name
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="companyName"
                              fullWidth
                              value={formikForUpdate.values.companyName}
                              onChange={formikForUpdate.handleChange}
                              error={
                                formikForUpdate.touched.companyName &&
                                Boolean(formikForUpdate.errors.companyName)
                              }
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">Email</MDTypography>
                            <MDInput
                              size="small"
                              type="email"
                              name="email"
                              fullWidth
                              value={formikForUpdate.values.email}
                              onChange={formikForUpdate.handleChange}
                              error={
                                formikForUpdate.touched.email &&
                                Boolean(formikForUpdate.errors.email)
                              }
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">
                              National Code
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="nationalCode"
                              fullWidth
                              value={formikForUpdate.values.nationalCode}
                              onChange={formikForUpdate.handleChange}
                              error={
                                formikForUpdate.touched.nationalCode &&
                                Boolean(formikForUpdate.errors.nationalCode)
                              }
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">City</MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="city"
                              fullWidth
                              value={formikForUpdate.values.city}
                              onChange={formikForUpdate.handleChange}
                              error={
                                formikForUpdate.touched.city &&
                                Boolean(formikForUpdate.errors.city)
                              }
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">Zip Code</MDTypography>
                            <MDInput
                              size="small"
                              type="number"
                              name="zipCode"
                              fullWidth
                              value={formikForUpdate.values.zipCode}
                              onChange={formikForUpdate.handleChange}
                              error={
                                formikForUpdate.touched.zipCode &&
                                Boolean(formikForUpdate.errors.zipCode)
                              }
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">Street</MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="street"
                              fullWidth
                              value={formikForUpdate.values.street}
                              onChange={formikForUpdate.handleChange}
                              error={
                                formikForUpdate.touched.street &&
                                Boolean(formikForUpdate.errors.street)
                              }
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12}>
                          <Collapse in={isErrorForUpdate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsErrorForUpdate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForUpdate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForUpdate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsSuccessForUpdate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Updated successfully
                            </Alert>
                          </Collapse>
                          <MDBox mt={2}>
                            <MDButton
                              color="info"
                              type="submit"
                              fullWidth
                              disabled={editButtonName === "Please wait..."}
                            >
                              {editButtonName}
                            </MDButton>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              {/* DELETE MODAL */}
              <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
                <MDCard sx={deleteStyle}>
                  <MDTypography>
                    Are you sure you want to delete?
                  </MDTypography>
                  <MDBox mt={2} display="flex" justifyContent="space-between">
                    <MDButton
                      color="info"
                      variant="outlined"
                      onClick={handleCloseDeleteModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      color="error"
                      onClick={deleteRecord}
                      disabled={deleteButtonName === "Please wait..."}
                    >
                      {deleteButtonName}
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isErrorForDelete}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            size="small"
                            onClick={() => setIsErrorForDelete(false)}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForDelete}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            size="small"
                            onClick={() => setIsSuccessForDelete(false)}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

            </Card>
          </Grid>
        </Grid>

      </MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />

      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => ({
  getManufacturerReducer: state.getManufacturerReducer,
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getManufacturer: (id, jwtToken) => dispatch(getManufacturer(id, jwtToken)),
  createManufacturer: (payload, jwtToken) =>
    dispatch(createManufacturer(payload, jwtToken)),
  editManufacturer: (payload, jwtToken) =>
    dispatch(editManufacturer(payload, jwtToken)),
  deleteManufacturer: (id, cd, jwtToken) =>
    dispatch(deleteManufacturer(id, cd, jwtToken)),

  uploadCsvForManufacturer: (payload, jwtToken) =>
    dispatch(uploadCsvForManufacturer(payload, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Manufacturer);
